 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		245: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"5dea399","1":"05fd0e6","2":"c1db4e6","3":"084d110","4":"beb7ecc","5":"9a070da","6":"aaed076","7":"179e7eb","8":"366a290","9":"fd8c423","10":"e4491c3","11":"c60fcb8","12":"346464c","13":"45fd425","14":"7e0fc88","15":"6a38cf8","16":"804adcb","17":"2f43196","18":"2978774","19":"e02618f","20":"96e0ef1","21":"6a7cfaf","22":"c3ec347","23":"7701295","24":"ba0c8a6","25":"5057c1e","26":"22029ef","27":"3102588","28":"fa9c9d5","29":"b7f2a4a","30":"f27578d","31":"a353916","32":"ce670a7","33":"8097175","34":"2f23f6f","35":"28e7281","36":"bd8571c","37":"99f87fe","38":"410f0ff","39":"e53671d","40":"4cb02c2","41":"b4243c9","42":"5a32232","43":"ef71346","44":"f14098e","45":"220d845","46":"0266198","47":"3ee95f1","48":"825a14e","49":"fdbeeb5","50":"82c183d","51":"0c674af","52":"0e5299f","53":"1e25a13","54":"3ee87b3","55":"6ca610b","56":"47bb65e","57":"a336d30","58":"65feee9","59":"6c27f64","60":"372b907","61":"5227062","62":"8992788","63":"2b2847b","64":"d41b9fd","65":"2d3ed7c","66":"ab7c15a","67":"36bccae","68":"3432eb4","69":"cf5048e","70":"e236da0","71":"ff1ea64","72":"9405418","73":"bbdf865","74":"aacec5b","75":"1a7ec0d","76":"3da3dce","77":"977ff64","78":"e30adf9","79":"fdf6e13","80":"62d34a2","81":"8208226","82":"4953fac","83":"9146687","84":"cc7a72c","85":"ec87bc1","86":"f209681","87":"c10b9ec","88":"1c05c76","89":"0eced75","90":"9bdcb17","91":"6f2875f","92":"d24c8bf","93":"e51d63c","94":"42d0531","95":"9e43ef6","96":"6e10f3a","97":"84acf84","98":"c7039bf","99":"2deafe3","100":"c0825f3","101":"e82c1bc","102":"1e63d38","103":"a3bf1e5","104":"e74f212","105":"f14d9a7","106":"d77d1e1","107":"6dffbb1","108":"88af18a","109":"95ebf2d","110":"fce412b","111":"9a5648f","112":"b22e04f","113":"5a347c1","114":"4a7bcd4","115":"a90bad0","118":"1125048","119":"c0d2de8","120":"823ad95","121":"ceaa83f","122":"79b57d7","123":"a8cd987","124":"97547ea","125":"7f2a721","126":"59b5e43","127":"f90acbd","128":"b3a7e86","129":"1e45cb5","130":"70e7c2c","131":"8f89248","132":"2ea1df1","133":"31fa27b","134":"1ce754c","135":"6032e7a","136":"31fa0bc","137":"71c88a6","138":"9555344","139":"98b92a2","140":"8548bad","141":"38d0600","142":"ec2eb95","143":"4f57cec","144":"b23d4c9","145":"da76f58","146":"e3a4dbe","147":"b5097bb","148":"75ccca8","149":"05d7fc1","150":"f8a2673","151":"e734799","152":"f1da94d","153":"e5e3fad","154":"f5a1a98","155":"a219f9f","156":"fc8af40","157":"6b65f1a","158":"02eff99","159":"06eeb2b","160":"c512540","161":"c5f7819","162":"ea17b26","163":"978defe","164":"ae2670a","165":"9a7c7d0","166":"de2ef65","167":"fa6a42b","168":"f56a81b","169":"d7371e3","170":"464d83b","171":"662e979","172":"607c78d","173":"9484e02","174":"e3573ae","175":"54e9d58","176":"9956816","177":"0061a32","178":"ff71c03","179":"b1c6799","180":"756eae1","181":"15517dd","182":"79f8128","183":"4a93845","184":"dabd946","185":"12b6257","186":"2ac8025","187":"8ad083a","188":"a70f34f","189":"09317ba","190":"3c126e8","191":"9872437","192":"32b3aef","193":"c173614","194":"ba9b46a","195":"b4d7f57","196":"c19cfef","197":"dc961ff","198":"ce6afda","199":"2c2aa74","200":"bc6b321","201":"194be4b","202":"2dd9712","203":"bf43713","204":"990716d","205":"18fe832","206":"ee2a7b7","207":"3e3806b","208":"fec0572","209":"29adc01","210":"5f0fd07","211":"6201afd","212":"3e60e7b","213":"2579cb4","214":"6468bf9","215":"f2893be","216":"ee83199","217":"b9603bf","218":"70eb633","219":"1ae6b66","220":"c5252bc","221":"f3762d9","222":"4d7b165","223":"2e95735","224":"f642053","225":"a097b25","226":"a9fe6e5","227":"1562c62","228":"928d7e0","229":"9c7daf5","230":"9cb564a","231":"30e280a","232":"118977e","233":"277a133","234":"4b4f12b","235":"57f4577","236":"64c75ff","237":"de04d87","238":"0f827bc","239":"27d7d46","240":"d3f039e","241":"80ac276","242":"918a3ce","243":"8e1b010","244":"b45ff46","247":"f91e999","248":"7ebc5c9","249":"e06c089","250":"589c9db","251":"85c7c0e","252":"925451a","253":"15fb65a","254":"fb02d8b","255":"17bb2cb","256":"9c1f039","257":"0955e53","258":"0f90159","259":"408212a","260":"d50bb24","261":"bfdba61","262":"47292ea","263":"18da460","264":"3386f12","265":"b146add","266":"33fd3a2","267":"5fc08c9","268":"cd2daff","269":"1d6730d","270":"3138d7a","271":"47bb0ef","272":"e8177b5","273":"6ab1688","274":"7603bc4","275":"21be007","276":"74a6567","277":"0301e4b","278":"f6452c3","279":"910a3c7","280":"9dabef1","281":"2202462","282":"752e2cf","283":"3f74388","284":"205c597","285":"df6965e","286":"4980ebd","287":"69e0f0d","288":"d5e2bb7","289":"941a6b0","290":"82b1e3e","291":"bed9314","292":"d49e8c3","293":"779b95a","294":"2e1315e","295":"a4a8064","296":"847d740","297":"7f2f4dd","298":"981d201","299":"204032f","300":"600266a","301":"2a68844","302":"3c062d6","303":"a45b550","304":"a29d2c0","305":"e0ade43","306":"bd0e67c","307":"6d78888","308":"5af0c63","309":"77bbcf8","310":"324a5b9","311":"fc99833","312":"f837167","313":"c485014","314":"13a3a04","315":"d16425a","316":"a59a5d7","317":"b3bfcb0","318":"3a1323c","319":"9013fe2","320":"1b44201","321":"63104ba","322":"b044373","323":"0aa6ac0","324":"b99a808","325":"4778512","326":"294e831","327":"7e678b0","328":"574f7b9","329":"a563e4f","330":"2fcb230","331":"c3ab04c","332":"510c25c","333":"0b8c2ed","334":"e24d985","335":"3a2b853","336":"31986c2","337":"a6ab4d1","338":"86a9cf9","339":"d26f5ae","340":"e3f37c1","341":"6103f97","342":"6c8c884","343":"f83af2c","344":"4210a4f","345":"85e69c8","346":"e30e3d7","347":"2011ef0","348":"325365d","349":"fa64e30","350":"d9a3416","351":"1461cc3","352":"c6b561b","353":"e7674f9","354":"8c2d49c","355":"00dc796","356":"7d5f816","357":"e99a47e","358":"52cf923","359":"c3e5d6d","360":"a00823e","361":"ba9addd","362":"4295ce7","363":"88f0acf","364":"f7eed32","365":"5b57225","366":"10b0048","367":"ac70403","368":"87ea838","369":"f8fe66f","370":"71444ae","371":"f65e23e","372":"b865443","373":"da2d31b","374":"55bc2f1","375":"b46803c","376":"a30c628","377":"cbfc0dd","378":"0427f94","379":"d591748","380":"24fd330"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d1mf56q6wc1y19.cloudfront.net/channels2022/220519/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
